
import React from 'react';
import { AppStep } from '../enums';

interface StepIndicatorProps {
  currentStep: AppStep;
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep }) => {
  const steps = [AppStep.BRAND, AppStep.ITEMS, AppStep.CONFIRM];
  const currentStepIndex = steps.indexOf(currentStep);

  // If on Welcome or Success, don't show or handle differently
  if (currentStep === AppStep.WELCOME || currentStep === AppStep.SUCCESS) return null;

  return (
    <div className="hidden sm:flex items-center gap-2 bg-white/50 backdrop-blur-md px-2 py-1.5 rounded-full border border-zinc-200/50 shadow-sm">
      {steps.map((step, index) => {
        const isActive = index <= currentStepIndex;
        const isCurrent = index === currentStepIndex;
        
        return (
          <div key={step} className="flex items-center">
             <div 
                className={`
                    h-2 rounded-full transition-all duration-500 ease-out
                    ${isActive ? 'bg-teal-500' : 'bg-zinc-200'}
                    ${isCurrent ? 'w-8' : 'w-2'}
                `}
             />
             {index < steps.length - 1 && <div className="w-2" />} 
          </div>
        );
      })}
      <span className="ml-2 text-xs font-bold text-zinc-400 w-12 text-center">
        {currentStepIndex + 1} / {steps.length}
      </span>
    </div>
  );
};
